import { IListing } from '../../@types/listing';
import { BaseIntegration } from '../types/base';
import { countIntegrationServices, serializeIntegration } from '../utils';
import { RentgrataFactory } from './factory';
import { RentgrataServices } from './types';

export default class Rentgrata implements BaseIntegration<RentgrataServices> {
  services: RentgrataServices;
  factory: RentgrataFactory;

  constructor(listing: IListing) {
    this.factory = new RentgrataFactory(listing);
    this.services = this.factory.create();
  }

  count() {
    return countIntegrationServices(this.services);
  }

  serialize() {
    return serializeIntegration(this);
  }
}
